import graphqlClient from '~/graphql/graphqlClient';
import {
  MutationLootCavernsTileArgs,
  LootCavernsTileResult,
} from 'dt-common/generated/graphql-types';

const mutation = `
mutation LootCavernsTile(
  $playerId: String!
  $game_submode: String!
  $tile_ids: [String!]!
) {
  lootCavernsTile(playerId: $playerId, game_submode: $game_submode, tile_ids: $tile_ids) {
    gold
    pd
    items
    tile_looted_ids
  }
}`;

export default async function mutationLootCavernsTile(args: MutationLootCavernsTileArgs) {
  return await graphqlClient.request<LootCavernsTileResult>('lootCavernsTile', mutation, args);
}
